import { HttpStatusCode } from "axios";

// A 4xx is a settled answer; only network failures and 5xx are transient.
export const isTransient = (error) =>
  !error?.status || error.status >= HttpStatusCode.InternalServerError;

export const retryTransient = (failureCount, error) =>
  isTransient(error) && failureCount < 1;
